import { createContext, useEffect, useLayoutEffect, useState } from "react";
import { addTask, addUser, findUser, startNewDay, updateTaskStatus } from "../firebase/firebase_functions";
import { toast } from "react-toastify";
import TaskItem from "../components/TaskItem";

export const AppMainContext = createContext(null);

export default function AppMainContextProvider ({children}){
    
    const errorOptions = {
        missingData:"עליך למלא את כל השדות הדרושים!",
        success:"הפעולה בוצעה בהצלחה!",
        failed:"הפעולה נכשלה",
        passwordMissMatch:"סיסמא שגויה!",
        userNotFound:"לא נמצא משתמש עם הפרטים שהוזנו.",
        connectionLost:"זמן החיבור פג תוקף, \nעליך להתחבר מחדש!",
    };

    // main
    const [dateTime, setDateTime] = useState("");
    const [connected,setConnected] = useState(()=>{
        const isConnected = localStorage.getItem("prodActive_connected");
        return isConnected ? JSON.parse(isConnected) : false;
    });
    const [currentUser,setCurrentUser] = useState(()=>{
        const user = localStorage.getItem("prodActive_currentUser");
        return user ? JSON.parse(user) : null;
    });
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const loadingOptions = {
        login:{
            data:["tasks","content","user","time zone","tasks"],
            header:"Loading",
        },
        signin:{
            data:["data","users","colors","connection","data"],
            header:"Loading"
        },
        logout:{
            data:["exit","colors","reset data","reset tasks","exit"],
            header:"Loading"
        }
        
    };
    const [loadingData, setLoadingData] = useState("");

    // signup
    const [signupFlag, setSignupFlag] = useState(false);
    const [signupName, setSignupName] = useState("");
    const [signupPass, setSignupPass] = useState("");

    // signin
    const [signinFlag, setSigninFlag] = useState(false);
    const [signinName, setSigninName] = useState("");
    const [signinPass, setSigninPass] = useState("");

    // addTask
    const [taskFlag, setTaskFlag] = useState(false);
    const [taskContent, setTaskContent] = useState("");
    const [taskConstancy, setTaskConstancy] = useState(false);

    // resetTasks
    const [resetFlag, setResetFlag] = useState(false);

    // history
    const [showHistoryFlag, setShowHistoryFlag] = useState(false);

    useLayoutEffect(()=>{localStorage.setItem("prodActive_currentUser", JSON.stringify(currentUser));},[currentUser])
    useLayoutEffect(()=>{
        localStorage.setItem("prodActive_connected", JSON.stringify(connected));
    },[connected])

    useEffect(()=>{
        if(!errorMessage || errorMessage === "") return;
        try{
            if(errorMessage === errorOptions.success){
                toast.success(errorMessage);
            }
            else if(errorMessage === errorOptions.missingData || errorMessage === errorOptions.userNotFound){
                toast.warn(errorMessage);
            }
            else if(errorMessage === errorOptions.failed){
                toast.error(errorMessage);
            }
        } catch(err){
            console.log(err);
        } finally{
            setErrorMessage("");
        }
    },[errorMessage])


// ===========================================================================
// Functions
// ===========================================================================

    // ===========================================================
    // signup
    // ===========================================================
    const handleSignup = async(nav)=>{
        if(!signupName || !signupPass || signupName.length === 0 || signupPass.length === 0){
            setErrorMessage(errorOptions.missingData);
            return;
        }
        setSignupFlag(true);
        try{
            const newUser = {
                uid: Date.now(),
                name: signupName.toLowerCase(),
                pass: signupPass,
                tasks: [],
                history: [],
                dark_mode: false,// for future use
            }
            const res = await addUser(newUser);
            await new Promise(resolve => setTimeout(resolve, 1000));
            if(res){
                setSignupFlag(false);
                setErrorMessage(errorOptions.success);
                setLoadingData(loadingOptions.signin);
                await new Promise(resolve => setTimeout(resolve, 2000));
                setIsLoading(true);
                await new Promise(resolve => setTimeout(resolve, 3500));
                nav("/");
            }
            else{
                setErrorMessage(errorOptions.failed);
            }
            return res;
        }
        catch(err){
            console.error("Error trying sign up new user: \n"+err);
        }
        finally{
            setSignupFlag(false);
            setIsLoading(false);
        }
    }

    // ===========================================================
    // signin
    // ===========================================================
    const handleSignin = async(nav, name, pass, toWait)=>{
        if(!name || !pass || name.length === 0 || pass.length === 0){
            setErrorMessage(errorOptions.missingData);
            return;
        }
        setSigninFlag(true);
        try{
            const userCredentials = {
                name: name.toLowerCase(),
                pass: pass
            }
            const res = await findUser(userCredentials);
            if(toWait){
                await new Promise(resolve => setTimeout(resolve, 1000));
            }
            if(!res){
                setErrorMessage(errorOptions.userNotFound);
            }
            else{
                setCurrentUser(res);
                setConnected(true);
                if(toWait){
                    setErrorMessage(errorOptions.success);
                }
                setSigninFlag(false);
                setLoadingData(loadingOptions.login);
                if(toWait){
                    await new Promise(resolve => setTimeout(resolve, 2000));
                }
                setIsLoading(true);
                await new Promise(resolve => setTimeout(resolve, 3500));
                nav(`/${res.id}/myTasks`);
            }

        } catch(err){
            console.error("Error on handle sign in: \n"+err);
        } finally{
            setSigninFlag(false);
            setIsLoading(false);
        }
    }

    
    // ===========================================================
    // addTask
    // ===========================================================
    const handleAddTask = async(nav)=>{
        if(!currentUser) {
            setErrorMessage(errorOptions.connectionLost);
            await new Promise(resolve => setTimeout(resolve, 2000))
            await handleLogout(nav);
            return;
        }
        if(!taskContent || taskContent.length === 0){
            setErrorMessage(errorOptions.missingData);
            return;
        }
        setTaskFlag(true);
        try{
            const newTask = {
                id: Date.now(),
                content: taskContent,
                constancy: taskConstancy,
                status: true,//active => not done yet
            }
            const res = await addTask(currentUser.id, newTask);
            await new Promise(resolve => setTimeout(resolve, 1000));
            const updatedUser = await findUser(currentUser);
            setCurrentUser(updatedUser);
            // console.log("res: "+res);
            if(res){
                setErrorMessage(errorOptions.success);
            }
            else{
                setErrorMessage(errorOptions.failed);
            }
        } catch(err){
            console.error("Error on adding task: \n"+err);
        } finally{
            setTaskFlag(false);
            setTaskConstancy(false);
            setTaskContent("");
        }
    }

    // ===========================================================
    // taskItem
    // ===========================================================
    const handleUpdateStatus = async(taskID, newStatus, nav)=>{
        if(!currentUser) {
            setErrorMessage(errorOptions.connectionLost);
            await new Promise(resolve => setTimeout(resolve, 2000))
            await handleLogout(nav);
            return;
        }
        if(!taskID ){
            setErrorMessage(errorOptions.failed);
            return;
        }
        try{
            const res = await updateTaskStatus(currentUser.id, taskID, newStatus);
            const updatedUser = await findUser(currentUser);
            setCurrentUser(updatedUser);
            if(res){
                setErrorMessage(errorOptions.success);
            }
            else{
                setErrorMessage(errorOptions.failed);
            }
        } catch(err){
            console.error(`Error on update task: [${taskID}] \n`+err);
        }
    }

    
    // ===========================================================
    // resetTasks
    // ===========================================================
    const handleResetTasks = async(nav)=>{
        if(!currentUser) {
            setErrorMessage(errorOptions.connectionLost);
            await new Promise(resolve => setTimeout(resolve, 2000))
            await handleLogout(nav);
            return;
        }
        if(!dateTime){
            setErrorMessage(errorOptions.failed);
            return;
        }
        setResetFlag(true);
        try{
            const res = await startNewDay(currentUser.id, dateTime);
            await new Promise(resolve => setTimeout(resolve, 2500));
            const updatedUser = await findUser(currentUser);
            setCurrentUser(updatedUser);
            setLoadingData(loadingOptions.login);
            await new Promise(resolve => setTimeout(resolve, 50));
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 3500));
            if(res){
                setErrorMessage(errorOptions.success);
            }
            else{
                setErrorMessage(errorOptions.failed);
            }
            // console.log("res: "+res);
        } catch(err){
            console.error("Error on reseting tasks: \n"+err);
        } finally{
            setResetFlag(false);
            setIsLoading(false);
        }
    }

                
    // ===========================================================
    // myTasks
    // ===========================================================
    const handleClock = ()=>{
            const updateTime = () => {
            const now = new Date();

            // Format date and time
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = now.getFullYear();

            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            const seconds = String(now.getSeconds()).padStart(2, "0");
            
            setDateTime(`${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`);
            
            if (hours === 23 && minutes === 59 && seconds === 59) {
                if (!currentUser) return; // prevent crash
                handleResetTasks();
            }

        };

        updateTime(); // set immediately on mount
        const interval = setInterval(updateTime, 1000); // update every 1s

        return () => clearInterval(interval); // cleanup on unmount
    }

    const deployTasks = ()=>{
        const list = currentUser?.tasks;
        if(list.length === 0){
            return <h2 style={{margin:"50px auto 0", fontSize:"32px"}}>הרשימה ריקה</h2>
        }
        return list.map((item, inx)=>{
            return <TaskItem key={`user_${currentUser?.uid}-item_${item.id}-index_${inx}`} item={item}/>
        })
    }

    const handleLogout = async(nav)=>{
        try{
            setLoadingData(loadingOptions.logout);
            await new Promise(resolve => setTimeout(resolve, 50));
            setIsLoading(true);
            setConnected(false);
            setCurrentUser(null);
            await new Promise(resolve => setTimeout(resolve, 3500));
            nav("/");

        } catch(err){
            console.error("Error loging out: \n"+err);
        } finally{
            setIsLoading(false);
        }
    }

    
    // ===========================================================
    // showHistory
    // ===========================================================
    const handleShowHistory = async(nav)=>{
        if(!currentUser) {
            setErrorMessage(errorOptions.connectionLost);
            await new Promise(resolve => setTimeout(resolve, 2000))
            await handleLogout(nav);
            return;
        }
        setShowHistoryFlag(true);
        try{
            await new Promise(resolve => setTimeout(resolve, 1500));
            setErrorMessage(errorOptions.success);
            setLoadingData(loadingOptions.login)
            await new Promise(resolve => setTimeout(resolve, 50));
            setIsLoading(true);
            await new Promise(resolve => setTimeout(resolve, 3500));
            nav(`/${currentUser?.id}/history`)
        } catch(err){
            console.error("Error on show history: \n"+err);
        } finally{
            setShowHistoryFlag(false);
            setIsLoading(false);
        }
    }


// ===========================================================================
// ===========================================================================
// ===========================================================================

    const val = {
        // main
        dateTime,
        setDateTime,
        currentUser,
        connected,
        errorMessage,
        isLoading,
        loadingData,

        // signup
        signupFlag,
        setSignupName,
        setSignupPass,
        handleSignup,

        // signin
        signinFlag,
        setSigninName,
        signinName,
        setSigninPass,
        signinPass,
        handleSignin,

        // myTasks
        handleClock,
        deployTasks,
        handleLogout,

        // addTask
        taskFlag,
        setTaskConstancy,
        taskConstancy,
        setTaskContent,
        taskContent,
        handleAddTask,

        // taskItem
        handleUpdateStatus,

        // resetTasks
        resetFlag,
        handleResetTasks,

        // history
        showHistoryFlag,
        handleShowHistory
    };

    return (
        <AppMainContext.Provider value={val}>
            {children}
        </AppMainContext.Provider>
    )
}